import { BaseResource } from "./base.resource";

export const TransporterAccessLevel = {
  None: 0,
  View: 1 << 0,
  Edit: 1 << 1,
  Delete: 1 << 2,
};

export class Transporter extends BaseResource {
  company: string;
  epaid: string;
  active: boolean;

  constructor(options?: any) {
    super(options);
    // Initialize properties...
  }

  get canView(): boolean {
    return (this.accessLevel & TransporterAccessLevel.View) > 0;
  }
  get canEdit(): boolean {
    return (this.accessLevel & TransporterAccessLevel.Edit) > 0;
  }
  get canDelete(): boolean {
    return (this.accessLevel & TransporterAccessLevel.Delete) > 0;
  }
}
